var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSvgAprobank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Marca_branco",
    "data-name": "Marca branco",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232,
    height: 83.325,
    viewBox: "0 0 232 83.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_485",
    "data-name": "Ret\\xE2ngulo 485",
    width: 232,
    height: 83.325,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_506",
    "data-name": "Grupo 506",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1233",
    "data-name": "Caminho 1233",
    d: "M57.259,29.285a3.838,3.838,0,0,0-.048-5.45L34.054,1.09A3.891,3.891,0,0,0,31.341,0a3.846,3.846,0,0,0-3.827,3.876l.154,16.658L1.111,47.573a3.838,3.838,0,0,0,.048,5.45L24.316,75.744a3.8,3.8,0,0,0,2.664,1.114,4.32,4.32,0,0,0,1.55-.315,3.8,3.8,0,0,0,2.35-3.585L30.727,56.3ZM30.227,3.851a1.135,1.135,0,0,1,.7-1.066A1.082,1.082,0,0,1,32.14,3L55.3,25.748a1.148,1.148,0,0,1,.024,1.623L30.692,52.461l-.32-34.681-.02.021ZM28.168,73.007a1.115,1.115,0,0,1-.315.8,1.148,1.148,0,0,1-1.623.024L3.073,51.085a1.148,1.148,0,0,1-.024-1.623L27.7,24.349l.32,34.706.013-.014Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1234",
    "data-name": "Caminho 1234",
    d: "M182.558,174.3c-3.8,0-6.274,2.277-7.436,6.855l-6.734,25.119h4.723l2.446-9.132h14.025l2.446,9.132h4.748l-6.782-25.119c-1.138-4.578-3.633-6.855-7.436-6.855m-5.741,18.264,3.052-11.409a2.755,2.755,0,0,1,5.426,0l3.052,11.409Z",
    transform: "translate(-127.6 -132.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1235",
    "data-name": "Caminho 1235",
    d: "M315.529,221.132q0-9.12-9.132-9.132H304.12q-9.12,0-9.132,9.132v22.842h4.578v-9.132h6.855c6.08,0,9.132-3.028,9.132-9.132h-.024Zm-4.554,4.578q0,4.578-4.578,4.578l-6.855-.024v-9.132c0-3.028,1.526-4.554,4.578-4.554H306.4c3.052,0,4.578,1.5,4.578,4.554Z",
    transform: "translate(-223.535 -160.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1236",
    "data-name": "Caminho 1236",
    d: "M396.088,221.132v13.71h4.578v-13.71c.024-3.028,1.526-4.554,4.554-4.554h6.855V212H405.22q-9.12,0-9.132,9.132",
    transform: "translate(-300.146 -160.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1237",
    "data-name": "Caminho 1237",
    d: "M477.021,212h-2.3q-9.12,0-9.132,9.132v4.578q0,9.12,9.156,9.132h2.277c6.08,0,9.132-3.028,9.132-9.132v-4.578c0-6.08-3.028-9.132-9.132-9.132m4.554,13.71q0,4.578-4.578,4.578H474.72q-4.578,0-4.578-4.578v-4.578c0-3.028,1.526-4.554,4.578-4.554H477c3.052,0,4.578,1.5,4.578,4.554Z",
    transform: "translate(-352.811 -160.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1238",
    "data-name": "Caminho 1238",
    d: "M578.4,183.432h-6.855V174.3h-4.554v22.842q0,9.12,9.132,9.132H578.4c6.08,0,9.132-3.028,9.132-9.132v-4.578c0-6.08-3.028-9.132-9.132-9.132m4.578,13.71q0,4.578-4.578,4.578H576.12q-4.578,0-4.578-4.578V188.01H578.4c3.052,0,4.578,1.5,4.578,4.554Z",
    transform: "translate(-429.649 -132.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1239",
    "data-name": "Caminho 1239",
    d: "M673.7,212.1h-9.132v4.554H673.7c3.052,0,4.578,1.5,4.578,4.554H671.42q-9.12,0-9.132,6.855t9.132,6.855v.024H673.7c6.08,0,9.132-3.028,9.132-9.132v-4.578c0-6.08-3.028-9.132-9.132-9.132m0,18.24H671.42c-3.052,0-4.578-.751-4.578-2.277,0-1.5,1.526-2.277,4.578-2.3h6.855q0,4.578-4.578,4.578",
    transform: "translate(-501.865 -160.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1240",
    "data-name": "Caminho 1240",
    d: "M774.7,212H772.42q-9.12,0-9.132,9.132v13.71h4.578v-13.71c0-3.028,1.526-4.554,4.578-4.554h2.277c3.052,0,4.578,1.5,4.578,4.554v13.71h4.578v-13.71q0-9.12-9.18-9.132",
    transform: "translate(-578.401 -160.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1241",
    "data-name": "Caminho 1241",
    d: "M890.725,183.432h-6.443l-9.132,9.132h-1.308V174.3h-4.554v31.974h4.554v-9.108h1.308l9.132,9.132h6.443l-11.433-11.433Z",
    transform: "translate(-658.725 -132.08)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvgAprobank);
export default __webpack_public_path__ + "static/media/loginSvgAprobank.2a261e1a9682b9907c89377f9c512f7f.svg";
export { ForwardRef as ReactComponent };